<!-- @format -->

@if (colors() && colors().length) {
	<div class="swatches hmf-display-flex hmf-align-items-center hmf-m-xs">
		@for (
			color of colors() | slice: 0 : maxColorSwatchesToShow();
			track trackBySwatch($index, color)
		) {
			<homefield-image-swatch
				class="hmf-m-xxxs"
				radius="0"
				height="44px"
				width="44px"
				[color]="color"
				[imageSrc]="imageSrcMap[color]"
				[imageSwatchHoverDimension]="true"
				[selected]="selectedSwatchColor() === color"
				(mouseover)="setImageColor(color)"
				onFocus="setImageColor(color)"
				(colorSwatchError)="
					handleImageError({ requestedImg: $event, color: color })
				"></homefield-image-swatch>
		}

		@if (colors().length > maxColorSwatchesToShow()) {
			<button
				homefield-text-link
				class="hmf-m-xxxs underlined-grey-button"
				[ariaLabel]="moreColorsButtonAriaLabel()"
				[linkURL]="assetSeoUrl()"
				[styled]="true"
				(click)="extraColorsClicked()">
				+{{ colors().length - maxColorSwatchesToShow() }}
			</button>
		}
	</div>
}
